<template>
  <div>
    <Loading :value="loading"></Loading>

    <!-- MODAL SHOW DE CONTRAT -->
    <v-dialog
      persistent
      v-model="dialogShowContrat"
      max-width="75%"
      scrollable
      :loading="loading"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="green">
          <v-toolbar-title>
            <span>Details du contrat {{ contratCourant.client }} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowContrat = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row>
            <v-flex md4>
              <p><b>Réference : </b> {{ contratCourant.ref }}</p>
              <p><b>Client : </b> {{ contratCourant.client }}</p>
              <p><b>Véhicule : </b> {{ contratCourant.vehicule }}</p>
              <p>
                <b>Montant total : </b>
                <v-chip label text-color="white" color="green">
                  {{ contratCourant.montantTotalFormat }} FCFA
                </v-chip>
              </p>
              <p><b>Date de début : </b> {{ contratCourant.dateDFormat }}</p>
            </v-flex>
            <v-flex md4>
              <p><b>Date de fin : </b> {{ contratCourant.dateSFormat }}</p>
              <p><b>Type de contrat : </b> {{ contratCourant.libelle }}</p>
              <p>
                <b>Nombre de (Jour, Mois, Année) : </b> {{ contratCourant.nbr }}
              </p>
              <p><b>Remise : </b> {{ contratCourant.remise }}</p>
              <p>
                <b>Avance à la location : </b> {{ contratCourant.avance }} %
              </p>
            </v-flex>
            <v-flex md4>
              <p>
                <b>Etat du contrat : </b>
                <v-chip
                  v-if="contratCourant.etat == 0"
                  label
                  text-color="white"
                  color="red"
                >
                  RESERVE
                </v-chip>
                <v-chip
                  v-if="contratCourant.etat == 1"
                  label
                  text-color="white"
                  color="green"
                >
                  ACTIF
                </v-chip>
                <v-chip
                  v-if="contratCourant.etat == 2"
                  label
                  text-color="white"
                  color="orange"
                >
                  TERMINE
                </v-chip>
                <v-chip
                  v-if="contratCourant.etat == 3"
                  label
                  text-color="white"
                  color="red"
                >
                  RESILIE
                </v-chip>
              </p>
              <p>
                <b>Kilometrage à la sortie : </b>
                {{ contratCourant.kilomSorti }} Km
              </p>
              <p>
                <b>Conducteur : </b>
                <span v-if="contratCourant.idCond != ''">{{
                  contratCourant.conducteur
                }}</span>
                <span v-else>Aucun conducteur attribué</span>
              </p>
              <p>
                <b>Date d'enrégistrement : </b> {{ contratCourant.created }}
              </p>
              <p>
                <b>Date de modification : </b> {{ contratCourant.modified }}
              </p>
            </v-flex>
          </v-layout>
          <br />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogCalendContrat"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title
            >Calendrier des contrats de locations</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialogCalendContrat = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container>
          <v-layout row>
            <v-flex xs12 class="mt-2">
              <section class="calendar-page-side-section">
                <div class="row colors-guide-list" style="text-align:center">
                  <div class="col-sm-3">
                    Actif:
                    <span
                      style="height:20px; width:80px;display:inline-block;background-color:#27ae60"
                    ></span>
                    Reservé:
                    <span
                      style="height:20px; width:80px;display:inline-block;background-color:#c0721d"
                    ></span>
                    Terminé:
                    <span
                      style="height:20px; width:80px;display:inline-block;background-color:#3135c0"
                    ></span>
                    Resilié:
                    <span
                      style="height:20px; width:80px;display:inline-block;background-color:#c0392b"
                    ></span>
                    Expiré:
                    <span
                      style="height:20px; width:80px;display:inline-block;background-color:#bcbfc0"
                    ></span>
                  </div>
                </div>
              </section>
              <full-calendar
                @event-selected="eventSelected"
                :config="config"
                :events="events"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "ModalCalendContrat",
  props: ["show"],
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      loading: false,
      dialogCalendContrat: false,
      dialogShowContrat: false,
      contratCourant: [],
      listContrat: [],
      events: [],
      config: {
        defaultView: "month",
        locale: "fr",
        eventRender: function(event, element) {}
      }
    };
  },
  computed: {},
  watch: {
    show: function(newValue, oldvalue) {
      this.dialogCalendContrat = newValue;
    }
  },
  methods: {
    loadContrat() {
      this.loading = true;
      let url = this.domaine + "contrat/index";
      this.$http.get(url).then(
        response => {
          this.events = response.body.calendContrat;
          this.listContrat = response.body.contrat;
          this.loading = false;
        },
        response => {
          this.loading = false;
          this.$message.error(
            "erreur lors du chargement des contrats de locations."
          );
        }
      );
    },

    eventSelected(event, jsEvent, view) {
      this.contratCourant = this.listContrat.find(cont => {
        return cont.id == event.idCont;
      });

      this.dialogShowContrat = true;
    }
  },
  mounted() {
    this.loadContrat();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/calendrier/ModalCalendContrat.vue